var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWrappedFlr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/wrapped-FLR") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/wrapped-FLR",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-1-(1)",
    transform: "translate(1.000000, 1.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#DB63CC",
    cx: 11,
    cy: 11,
    r: 11
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(5.667179, 6.085698)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.27120842,3.96741336 L3.0502626,3.96362244 C1.62698096,3.96362244 0.442948795,5.08910588 0.405865509,6.53597549 C0.405039548,6.57472717 0.436630587,6.60631821 0.475382263,6.60673942 L5.69632808,6.61010913 L5.69632808,6.61095156 C7.11960972,6.61095156 8.30364188,5.48546812 8.34072517,4.03859851 C8.34155113,3.99984683 8.30996009,3.96825579 8.27120842,3.96783458 L8.27120842,3.96741336 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9172739,0.00379092476 L3.04984139,0 C1.62655975,0 0.442527581,1.12548344 0.405444295,2.57235305 C0.404618334,2.61110473 0.436209373,2.64269577 0.474961049,2.64311698 L8.34239356,2.64648669 L8.34239356,2.64732912 C9.7656752,2.64732912 10.9497074,1.52184568 10.9867906,0.0749760674 C10.9876166,0.0362243921 10.9560256,0.00463335248 10.9172739,0.00421213862 L10.9172739,0.00379092476 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    transform: "translate(1.728626, 9.232912) rotate(-22.500000) translate(-1.728626, -9.232912) ",
    cx: 1.72862558,
    cy: 9.23291228,
    r: 1.32303274
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#3A4374",
    cx: 4.5,
    cy: 4.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("text", {
    id: "w",
    fontFamily: "Inter-Regular_Bold-Italic, Inter",
    fontSize: 7,
    fontStyle: "italic",
    fontWeight: "bold",
    letterSpacing: -0.175166064,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1.5,
    y: 6.2
  }, "w")), /*#__PURE__*/React.createElement("path", {
    d: "M4.5,0 C6.98528137,0 9,2.01471863 9,4.5 C9,6.98528137 6.98528137,9 4.5,9 C2.01471863,9 0,6.98528137 0,4.5 C0,2.01471863 2.01471863,0 4.5,0 Z M3.02526855,2.38181818 L1.9554055,2.38181818 L2.3570945,6.2 L3.47667347,6.2 L4.53068959,3.79771174 L4.57842463,3.79771174 L4.83694735,6.2 L5.95652632,6.2 L7.6309426,2.38181818 L6.56107955,2.38181818 L5.5528176,4.9312733 L5.51902632,4.9312733 L5.32016269,2.38181818 L4.27018599,2.38181818 L3.22413219,4.94715909 L3.19034091,4.94715909 L3.02526855,2.38181818 Z",
    id: "Combined-Shape",
    fill: "#3A4374"
  }), /*#__PURE__*/React.createElement("g", {
    id: "w",
    transform: "translate(1.955405, 2.381818)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrappedFlr);
export default __webpack_public_path__ + "static/media/wrapped-FLR.33567de8f16c2897a409ba166523d08e.svg";
export { ForwardRef as ReactComponent };